import { IApplicationState } from '../../types/redux';

export const selectRegionId = (state: IApplicationState) => state.calculator.initialFormState.regionId;
